import { useState } from "react";
import { navItems, routeToPath, onNavClick } from "../router";
import { site } from "../data/site";
import { callApi, getSession, setSession } from "../api";

type Props = { route: string; onNavigate: (route: string) => void };

export function SiteHeader({ route, onNavigate }: Props) {
  const [signedIn, setSignedIn] = useState(() => Boolean(getSession()));

  async function signOut() {
    // 先请后端吊销会话，再清本地；顺序反了会因为缺少 userSession 而吊销失败
    await callApi("auth.logout");
    setSession(null);
    setSignedIn(false);
    onNavigate("home");
  }

  return (
    <header className="site-header">
      <a
        className="brand"
        href={routeToPath("home")}
        onClick={(e) => onNavClick(e, "home", onNavigate)}
        aria-label={`${site.name}首页`}
      >
        <span className="brand-mark">
          <img src="/tengyunzi-logo.png" alt={`${site.name} logo`} width={38} height={38} />
        </span>
        <span className="brand-text">{site.name}</span>
      </a>
      <nav className="site-nav" aria-label="主导航">
        {navItems.map((item) => (
          <a
            key={item.key}
            href={routeToPath(item.key)}
            className={route === item.key ? "active" : undefined}
            aria-current={route === item.key ? "page" : undefined}
            onClick={(e) => onNavClick(e, item.key, onNavigate)}
          >
            {item.label}
          </a>
        ))}
      </nav>
      <div className="site-account">
        {signedIn ? (
          <>
            <button type="button" onClick={() => onNavigate("profile")}>
              个人资料
            </button>
            <button type="button" onClick={signOut}>
              退出登录
            </button>
          </>
        ) : (
          <button type="button" onClick={() => onNavigate("auth")}>
            登录 / 注册
          </button>
        )}
      </div>
    </header>
  );
}
